/**
 * Türkiye cep telefonu denetimi — başvuru ve erken erişim formlarının tek kaynağı.
 * Arka uç karşılığı: backend/src/utils/telefonGecerli.js (aynı kural; guard: backend/tests/telefon-gecerli-drift.js).
 * 10 hane 5xxxxxxxxx ya da 11 hane 05xxxxxxxxx; boşluk, tire, parantez yok sayılır.
 */
export const isValidTurkishPhone = (val: string): boolean => {
  const digits = val.replace(/\D/g, '');
  if (digits.length === 10) return digits.startsWith('5');
  if (digits.length === 11) return digits.startsWith('05');
  return false;
};
